import styled from 'styled-components';

/** @visibleName Visually Hidden */
const VisuallyHidden = styled.div`
  position: absolute;
  top: -9999px;
  left: -9999px;
`;

/** @component */
export default VisuallyHidden;
